<template>
	<action-sidebar
		title="Asignar Integración"
		:value="true"
		@close-modal="closeModal"
	>
		<div class="px-3 pt-4">
			<v-flex xs12 mb-4>
				<v-select
					v-if="openEdiType"
					background-color="white"
					box
					:disabled="disabledEdit"
					class="body-1"
					hide-details
					item-text="name"
					item-value="name"
					label="Tipo de Integración"
					:items="typeIntegration"
					v-model="process.typeIntegration"
					return-object
					@input="setValueTypeIntegration"
				></v-select>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-select
					background-color="white"
					box
					class="body-1"
					hide-details
					item-text="name"
					item-value="name"
					label="Categorías"
					:items="categories"
					return-object
					:disabled="disabledEdit"
					v-model="process.category"
					@input="setValueCategory"
				></v-select>
				<span class="form-group__message" v-if="!$v.process.category.required">
					Este campo es requerido.
				</span>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-select
					background-color="white"
					box
					class="body-1"
					hide-details
					item-text="name"
					item-value="name"
					label="Integración"
					:items="integrations"
					:disabled="disabledEdit"
					v-model="process.integration"
					return-object
				></v-select>
				<span class="form-group__message" v-if="!$v.process.integration.required">
					Este campo es requerido.
				</span>
			</v-flex>
			<v-layout>
				<v-flex xs9 mb-4>
					<v-text-field
						background-color="white"
						box
						placeholder="0.00"
						class="body-1"
						hide-details
						label="Precio"
						type="number"
						v-model="process.price"
					></v-text-field>
					<span class="form-group__message" v-if="!$v.process.price.required">
						Este campo es requerido.
					</span>
				</v-flex>
				<v-flex xs3 ml-4>
					<v-btn
						:disabled="$v.$invalid"
						color="primary"
						@click="assignIntegration"
					>
						{{ titleButton }}
						<v-icon>add</v-icon>
					</v-btn>
				</v-flex>
				<v-flex xs3 v-if="cancelEdit">
					<v-btn
						color="error"
						@click="cancelEditIntegration"
					>
						Cancelar
					</v-btn>
				</v-flex>
			</v-layout>
			<app-table
				name="table-process-integration"
				class="mt-2"
				:columns="columns"
				:rows="rows"
				:input-search="false"
			>
				<template slot="rows" slot-scope="props">
					<td v-show="showRow(columns, 1)" class="is-not-selectable">{{ props.row.categoryName }}</td>
					<td v-show="showRow(columns, 2)">{{ props.row.name }}</td>
					<td v-show="showRow(columns, 3)">{{ props.row.price }}</td>
					<td v-show="showRow(columns, 4)">
						<v-layout row justify-center>
							<v-flex xs3>
								<app-tooltip-button
									color="green"
									icon="edit"
									text="Editar"
									@click-icon="editIntegration(props.row)"
								/>
							</v-flex>
							<v-flex xs3>
								<app-tooltip-button
									color="error"
									icon="delete"
									text="Elimimar"
									@click-icon="openDialog(props.row)"
								/>
							</v-flex>
							<v-flex xs3>
								<v-tooltip top>
									<v-switch
										slot="activator"
										class="ml-3 mt-0"
										hide-details
										v-model="props.row.flagDefault"
										@change="activeSwitch(props.row)"
									></v-switch>
									<span>{{ labelActive(props.row.flagDefault) }}</span>
								</v-tooltip>
							</v-flex>
						</v-layout>
					</td>
				</template>
			</app-table>
			<v-dialog v-model="dialogIntegration" persistent max-width="500">
				<v-card>
					<v-card-title class="subheading">{{ dialogMessage }}</v-card-title>
					<v-card-actions class="justify-center">
						<v-btn
							class="btn-action"
							color="green"
							dark
							@click.native="deleteIntegration"
						>
							SI
						</v-btn>
						<v-btn
							class="btn-action"
							color="error"
							dark
							@click.native="closeDialog"
						>
							NO
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					:is-loading="false"
					success-text="Guardar"
					@accept-button-clicked="saveProcess"
					@cancel-button-clicked="closeModal"
				></modal-sidebar-button>
			</section>
	  	</div>
	</action-sidebar>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import { required } from 'vuelidate/lib/validators';
import actionSidebar from '@/components/shared/action-sidebar';

function created() {
	this.loadTypeIntegration();
	this.loadListCategories();
}

function activeSwitch(row) {
	if (row.flagDefault) {
		const categories = this.rows.some(r => r.categoryId ===
			row.categoryId && (r.flagDefault && r.id !== row.id));
		if (categories) {
			const index = this.rows.findIndex(p => p.categoryId === row.categoryId);
			if (index > -1) {
				this.rows[index].flagDefault = false;
			}
			this.showError('Solo se debe activar uno por categoria.');
		}
	}
}

async function loadListCategories() {
	const idTemplate = this.$route.params.id;
	const headers = {
		Accept: process.env.ACCEPT_SERVICE_V2,
	};
	const { data: response } = await this.$http.get(`template/${idTemplate}`, { headers });
	if (response.data.integrations) {
		this.rows = response.data.integrations.integrations || [];
	} else {
		this.showError('Usted no tiene configurado este proceso.');
	}
}

function labelActive(value) {
	return value ? 'Activar Integración' : 'Desactivar Integración';
}

async function saveProcess() {
	const body = {
		integrations: this.rows.map((p) => {
			const newOjb = {};
			newOjb.price = p.price;
			newOjb.flagDefault = p.flagDefault;
			newOjb.id = p.id;
			return newOjb;
		}),
		templateCode: this.$route.params.codeTemplate,
	};
	try {
		await this.$http.patch('integrations-template', body);
		this.showNotification('La Integración fue asignada correctamente.');
		this.clearForm();
		this.closeModal();
	} catch (error) {
		this.showError();
	}
}

function assignIntegration() {
	const newobj = {
		idRow: this.process.id || this.rows.length + 1,
		id: this.process.integration.id,
		idCategory: this.process.category.id,
		categoryName: this.process.category.name,
		typeIntegration: this.process.typeIntegration,
		idTypeIntegration: this.process.typeIntegration.id,
		name: this.process.integration.name,
		price: this.process.price,
		flagDefault: false,
	};
	if (this.process.id) {
		const indexId = this.rows.findIndex(r => r.id === this.process.id);
		if (indexId > -1) {
			this.rows[indexId].price = newobj.price;
			this.titleButton = 'Asignar';
		}
	} else {
		const index = this.rows.findIndex(r => r.id === this.process.integration.id);
		if (index > -1) {
			this.showError('Ya tiene asignado esta categoria.');
		} else {
			this.rows.push(newobj);
		}
	}
	this.cancelEdit = false;
	this.clearForm();
}

function clearForm() {
	this.process = {
		typeIntegration: '',
		category: '',
		integration: '',
		price: null,
	};
	this.disabledEdit = false;
	this.openEdiType = true;
}

function disabled() {
	return this.rows.length === 0;
}

async function loadTypeIntegration() {
	try {
		const response = await this.$http.get('type-integrations');
		this.typeIntegration = response.data.data;
		if (this.typeIntegration.length === 1) {
			this.process.typeIntegration = this.typeIntegration[0];
			this.loadCategories(this.typeIntegration[0].id);
		}
	} catch (error) {
		this.showError();
	}
}

async function loadCategories(id) {
	const params = {
		typeIntegrationId: id,
	};
	try {
		const response = await this.$http.get('categories', { params });
		this.categories = response.data.data;
		if (this.categories.length === 1) {
			this.process.category = this.categories[0];
			this.loadIntegration(this.categories[0].id);
		}
	} catch (error) {
		this.showError();
	}
}

async function loadIntegration(id) {
	const params = {
		categoryId: id,
	};
	try {
		const response = await this.$http.get('integrations', { params });
		this.integrations = response.data.data;
		if (this.integrations.length === 1) {
			this.process.integration = this.integrations[0];
		}
	} catch (error) {
		this.showError();
	}
}

function closeModal() {
	this.goTo('page-configuration-process');
}

function editIntegration(row) {
	this.process.id = row.id;
	this.process.category = row.categoryName;
	this.process.price = row.price;
	this.process.integration = row.name;
	this.openEdiType = false;
	this.disabledEdit = true;
	this.cancelEdit = true;
	this.titleButton = 'Actualizar';
}

function openDialog(row) {
	this.dialogMessage = `¿Desea eliminar la integración '${row.name}' ?`;
	this.idIntegration = row.id;
	this.dialogIntegration = true;
}

function closeDialog() {
	this.dialogMessage = '';
	this.dialogIntegration = false;
	this.idIntegration = null;
}

function deleteIntegration() {
	const indexIntegration = this.rows.findIndex(r => r.id === this.idIntegration);
	if (indexIntegration > -1) {
		this.rows.splice(indexIntegration, 1);
		this.showNotification('La integración fue eliminada correctamente.');
		this.closeDialog();
	}
}

function setValueTypeIntegration(item) {
	this.loadCategories(item.id);
}

function setValueCategory(row) {
	this.loadIntegration(row.id);
	if (row.id === 1) {
		this.process.price = 0;
	}
}

function cancelEditIntegration() {
	this.process = {
		typeIntegration: '',
		category: '',
		integration: '',
		price: null,
	};
	this.titleButton = 'Asignar';
	this.disabledEdit = false;
	this.openEdiType = true;
	this.cancelEdit = false;
}

function validations() {
	return {
		process: {
			category: { required },
			integration: { required },
			price: { required },
		},
	};
}

function data() {
	return {
		titleButton: 'Asignar',
		cancelEdit: false,
		categories: [],
		columns: [
			{ id: 1, name: 'Categoria', value: 'category', checked: true, visible: true },
			{ id: 2, name: 'Integración', value: 'type', checked: true, visible: true },
			{ id: 3, name: 'Precio', value: 'price', checked: true, visible: true },
			{ id: 4, name: 'Acciones', checked: true, visible: true },
		],
		dialogMessage: '',
		dialogIntegration: false,
		disabledEdit: false,
		integrations: [],
		rows: [],
		openEdiType: true,
		process: {
			typeIntegration: '',
			category: '',
			integration: '',
			price: null,
		},
		typeIntegration: [],
	};
}

export default {
	name: 'page-configuration-process-assign',
	data,
	created,
	components: {
		appTooltipButton,
		actionSidebar,
	},
	computed: {
		disabled,
	},
	methods: {
		activeSwitch,
		assignIntegration,
		cancelEditIntegration,
		closeDialog,
		closeModal,
		clearForm,
		deleteIntegration,
		editIntegration,
		labelActive,
		loadCategories,
		loadIntegration,
		loadListCategories,
		loadTypeIntegration,
		openDialog,
		saveProcess,
		setValueTypeIntegration,
		setValueCategory,
	},
	validations,
};
</script>


// WEBPACK FOOTER //
// src/components/process/page-configuration-process-assign.vue